import { useContext } from 'react';
import { SceneCtx } from './SceneContext';

export { SceneProvider } from './SceneContext';
export const useScene = () => useContext(SceneCtx)!;
